import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import useCountriesData, {
  getCountryStates,
  getStateCities,
} from '../../hooks/useCountriesData';
import useOptionsData from '../../hooks/useOptionsData';
import FormButton from '../Form/FormButton';
import FormInput from '../Form/FormInput';
import FormLabel from '../Form/FormLabel';
import FormSelect from '../Form/FormSelect';

export interface Props {
  onSubmit: (data: any) => void;
}

const DEFAULT_COUNTRY = 'Colombia';

export default function LoginSignup(props: Props) {
  const { register, handleSubmit, errors, watch, setValue } = useForm({
    defaultValues: {
      role: '',
      name: '',
      lastName: '',
      password: '',
      sellerType: '',
      phone: '',
      email: '',
      'document.type': '',
      'address.country': DEFAULT_COUNTRY,
      'address.state': '',
      'address.city': '',
    },
  });
  const { data: optionsData } = useOptionsData();
  const { data: countriesData } = useCountriesData();

  const watchRole = watch('role');
  const watchState = watch('address.state');
  const watchCountry = watch('address.country');

  useEffect(() => {
    register('role', { required: true });
    setValue('role', 'comprador');
  }, [register]);

  const states = getCountryStates(watchCountry, countriesData);

  return (
    <form style={{ minHeight: 300 }} onSubmit={handleSubmit(props.onSubmit)}>
      {/* <FormLabel>Elija un modo de registro</FormLabel> */}
      {!watchRole && (
        <>
          <FormButton
            fullWidth
            variant="contained"
            onClick={() => setValue('role', 'comprador')}
          >
            Comprador
          </FormButton>
          <FormButton
            fullWidth
            variant="contained"
            onClick={() => setValue('role', 'vendedor')}
          >
            Vendedor
          </FormButton>
        </>
      )}

      {(watchRole === 'comprador' || watchRole === 'vendedor') && (
        <>
          {/* <FormButton
            style={{ textTransform: 'uppercase' }}
            fullWidth
            variant="outlined"
            onClick={() => setValue('role', undefined)}
          >
            {watchRole}
          </FormButton> */}

          <FormInput
            name="name"
            placeholder="Nombre*"
            inputRef={register({ required: true })}
            error={errors.name?.type === 'required' && 'Campo obligatorio.'}
          />

          <FormInput
            name="lastName"
            placeholder="Apellidos*"
            inputRef={register({ required: true })}
            error={errors.lastName?.type === 'required' && 'Campo obligatorio.'}
          />

          <FormInput
            type="email"
            name="email"
            placeholder="Correo electrónico*"
            error={
              errors.email?.type === 'required'
                ? 'Debes indicar un correo electrónico.'
                : errors.email?.type === 'pattern'
                ? 'Debes indicar un correo electrónico válido.'
                : null
            }
            inputRef={register({
              required: true,
              pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            })}
          />

          <FormInput
            type="password"
            name="password"
            autoComplete="new-password"
            placeholder="Contraseña*"
            inputRef={register({ required: true, minLength: 8 })}
            error={
              errors.password?.type === 'required'
                ? 'Contraseña obligatoria.'
                : errors.password?.type === 'minLength'
                ? 'Tu contraseña debe tener al menos 8 caracteres.'
                : null
            }
          />

          {watchRole === 'vendedor' && (
            <>
              <FormSelect
                name="sellerType"
                inputRef={register({ required: true })}
                error={
                  errors.sellerType?.type === 'required' && 'Campo obligatorio.'
                }
              >
                <option value="">Tipo de vendedor*</option>
                {optionsData &&
                  optionsData.sellerType.map((el: string) => (
                    <option key={el} value={el}>
                      {el}
                    </option>
                  ))}
              </FormSelect>

              <FormInput
                type="tel"
                name="phone"
                placeholder="Número celular*"
                inputRef={register({ required: true })}
                error={
                  errors.phone?.type === 'required' && 'Campo obligatorio.'
                }
              />

              <FormInput
                name="company"
                placeholder="Razón social"
                inputRef={register}
              />

              <FormSelect
                name="document.type"
                inputRef={register({ required: true })}
                error={
                  (errors as any).document?.type?.type === 'required' &&
                  'Campo obligatorio.'
                }
              >
                <option value="">Tipo de documento*</option>
                {optionsData &&
                  optionsData.document.map((el: string) => (
                    <option key={el} value={el}>
                      {el}
                    </option>
                  ))}
              </FormSelect>

              <FormInput
                type="number"
                name="document.number"
                placeholder="Número del documento"
                inputRef={register}
              />

              <FormSelect name="address.country" inputRef={register}>
                <option value="">País</option>
                {countriesData &&
                  countriesData.map((el: any) => (
                    <option key={el.name} value={el.name}>
                      {el.name}
                    </option>
                  ))}
              </FormSelect>

              <FormSelect name="address.state" inputRef={register}>
                <option value="">Estado</option>
                {states.map((el) => (
                  <option key={el.value} value={el.value}>
                    {el.name}
                  </option>
                ))}
              </FormSelect>

              <FormSelect name="address.city" inputRef={register}>
                <option value="">Ciudad</option>
                {getStateCities(watchState, states).map((el) => (
                  <option key={el.value} value={el.value}>
                    {el.name}
                  </option>
                ))}
              </FormSelect>

              <FormInput
                name="address.name"
                placeholder="Dirección"
                inputRef={register}
              />
            </>
          )}

          <FormLabel>
            Al seleccionar Aceptar y continuar, acepta los{' '}
            <Link target="_blank" to="/companyTerms">
              Términos del servicio
            </Link>{' '}
            y la{' '}
            <Link target="_blank" to="/cookies-politics">
              Política de privacidad
            </Link>{' '}
            de Hauscanner.
          </FormLabel>

          <FormButton
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
          >
            Aceptar y continuar
          </FormButton>
        </>
      )}
    </form>
  );
}
